export { default } from './my-equipment-ga-tracking';
